export default __webpack_public_path__ + "static/media/logo-sm.d3283f06.png";